import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function stripDiacritics(value = "") {
  return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
